module.exports = __webpack_public_path__ + "img/ic-jgdw-point.6229f946.png";